import { useMemo } from "react";

const weekSeconds = 1000 * 60 * 60 * 24 * 7;

export const useChatAgeSort = (chats) => {
    const [recent, older] = useMemo(() => {
        const recent = [];
        const older = [];
        const threshold = Date.now() - weekSeconds;

        chats
            .slice()
            .map((chat) => {
                chat.updatedOn = new Date(chat.updatedOn);
                return chat;
            })
            .sort((a, b) => {
                return b.updatedOn - a.updatedOn;
            })
            .map((chat) => {
                const isRecent = chat.updatedOn > threshold;
                if (isRecent) {
                    recent.push(chat);
                } else {
                    older.push(chat);
                }
            });

        return [recent, older];
    }, [chats]);

    return [recent, older];
};
